import { Record } from 'immutable';
export default Record({
  id: undefined,
  message: undefined,
  type: undefined,
  titleText: undefined
}, 'Alert');